import {
  ClientNameGetBeautyOutput,
  ClientsGetBeautyOutput,
} from "@okeys/shared-utils"
import { useQuery } from "@tanstack/react-query"
import { customAxios } from "../utils/customAxios/customAxios"
import { getToken } from "../utils/functions/getToken"

/**
 * Hook pour récupérer les informations d'un client par son ID
 * @param clientId ID du client à récupérer
 * @returns Les informations du client et l'état de la requête
 */
export const useClientNameQuery = (clientId: string) => {
  const { data, isError, isLoading, error } = useQuery({
    queryKey: ["clientName", clientId],
    queryFn: async (): Promise<ClientNameGetBeautyOutput> => {
      try {
        const token = await getToken()
        const response = await customAxios.get("/client/name", {
          params: {
            clientId,
          },
          headers: {
            Authorization: token || "",
          },
        })
        return response.data as ClientNameGetBeautyOutput
      } catch (err) {
        console.error("Error fetching client name:", err)
        throw err
      }
    },
    enabled: !!clientId,
  })
  return { client: data, isError, isLoading, error }
}

/**
 * Hook pour récupérer tous les clients abonnés au shop de l'utilisateur connecté
 * @returns La liste des clients et l'état de la requête
 */
export const useClientsQuery = () => {
  const { data, isError, isLoading, error, refetch } = useQuery({
    queryKey: ["clients"],
    queryFn: async (): Promise<ClientsGetBeautyOutput> => {
      try {
        const token = await getToken()
        const response = await customAxios.get("/client/all", {
          headers: {
            Authorization: token || "",
          },
        })
        return response.data as ClientsGetBeautyOutput
      } catch (err) {
        console.error("Error fetching clients:", err)
        throw err
      }
    },
  })
  return {
    clients: data?.clients || [],
    isError,
    isLoading,
    error,
    refetch,
  }
}
